import * as React from 'react';
import styles from './big-svg-checkbox.scss';

export interface BigSVGCheckboxProps {
  isChecked: boolean;
}

export const BigSVGCheckbox = (props:BigSVGCheckboxProps) => (
  <div className={`${styles.bigCheckbox} big ${props.isChecked ? styles.isChecked : ''}`}>
    <svg viewBox="8742 1111 22 22" height="22px" width="22px">
      <g transform="translate(7701 554)">
        <rect fill="#fff" width="20" height="20" transform="translate(1042 558)"/>
        <path className={styles.check}
        // tslint:disable-next-line:max-line-length
        d="M798.656,976.4a2.219,2.219,0,0,1,1.711.733,2.413,2.413,0,0,1,.733,1.711v17.111a2.506,2.506,0,0,1-2.444,2.445H781.545a2.22,2.22,0,0,1-1.711-.733,2.413,2.413,0,0,1-.733-1.711V978.845a2.506,2.506,0,0,1,2.445-2.444Zm-11,17.111,11-11-1.711-1.833-9.289,9.289-4.4-4.4-1.711,1.711Z"
        transform="translate(261.9 -419.4)" />
        <path className={styles.border}
        // tslint:disable-next-line:max-line-length
        d="M835.656,976.4a2.506,2.506,0,0,1,2.444,2.444v17.111a2.506,2.506,0,0,1-2.444,2.445H818.544a2.506,2.506,0,0,1-2.444-2.445V978.845a2.506,2.506,0,0,1,2.444-2.444Zm0,2.444H818.544v17.111h17.111Z" transform="translate(224.9 -419.4)" />
      </g>
    </svg>
  </div>
);
